/* eslint react/prop-types: 0 */
import React from 'react';
import RaceDayLink from '../../shared/links/RaceDayLink';
import { formatDate } from '../../utils/date';

const columns = (name, id) => [
    {
        key: 'raceDate',
        header: 'date',
        cell: ({ raceDate }) => (
            <RaceDayLink
                courseName={name}
                courseUid={+id}
                raceDate={raceDate}
            >
                <span className="hidden-sm-up">
                    {formatDate(raceDate, 'DDMMMYY')}
                </span>
                <span className="hidden-xs-down">
                    {formatDate(raceDate, 'dddd, D MMMM Y')}
                </span>
            </RaceDayLink>
        ),
    },
    {
        key: 'raceDatetimeFirst',
        header: 'first race',
        cell: ({ raceDatetimeFirst }) =>
            formatDate(raceDatetimeFirst, 'h:mm'),
    },
    {
        key: 'raceDatetimeLast',
        header: 'last race',
        cell: ({ raceDatetimeLast }) =>
            formatDate(raceDatetimeLast, 'h:mm'),
    },
    {
        key: '',
        header: ' ',
        cell: () => null,
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/course/raceDays/columns.jsx